import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import { Link } from 'react-router-dom';

// Fix Leaflet marker icons
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
});

const MapView = ({ immobilisations = [], center = [9.5412, -13.2317], zoom = 12 }) => {
  // Filter immobilisations that have GPS coordinates
  const markeredImmobilisations = immobilisations.filter(
    (i) => i.latitude && i.longitude
  );

  return (
    <div className="map-container">
      <MapContainer center={center} zoom={zoom} scrollWheelZoom={true}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        {markeredImmobilisations.map((immobilisation) => (
          <Marker
            key={immobilisation.id}
            position={[immobilisation.latitude, immobilisation.longitude]}
          >
            <Popup>
              <div style={{ textAlign: 'center', minWidth: '200px' }}>
                {immobilisation.photo && (
                  <img
                    src={immobilisation.photo}
                    alt={immobilisation.nom}
                    style={{ width: '100%', height: '120px', objectFit: 'cover', borderRadius: '4px', marginBottom: '0.5rem' }}
                  />
                )}
                <h4 style={{ margin: '0.5rem 0' }}>{immobilisation.nom}</h4>
                <p style={{ fontSize: '0.875rem', margin: '0.25rem 0' }}>
                  <strong>État:</strong> {immobilisation.etat}
                </p>
                <Link to={`/immobilisations/${immobilisation.id}`} className="btn btn-primary btn-sm" style={{ width: '100%', marginTop: '0.5rem' }}>
                  Voir détails
                </Link>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default MapView;
